// core
import { Routes } from '@angular/router';
// own
import { ReceivedReportComponent } from '@manager-app/reports/shipment/received/received-report.component';
import { SaleReportComponent } from '@manager-app/reports/sale/sale-report.component';
import { RefundReportComponent } from '@manager-app/reports/refund/refund-report.component';
import { RevenueReportComponent } from '@manager-app/reports/revenue/revenue-report.component';
import { RefundedReportComponent } from '@manager-app/reports/shipment/refunded/refunded-report.component';
import { FeedbackRatingReportComponent } from '@manager-app/reports/feedback-rating/feedback-rating-report.component';
import { UserReceivedOrderComponent } from '@manager-app/reports/user-received-order/user-received-order.component';
import { ProductDiscardReportComponent } from '@manager-app/reports/product-discard/product-discard-report.component';
import { ProductDiscardInfoComponent } from '@manager-app/reports/product-discard/info/product-discard-info.component';
import { StorageFlowComponent } from '@manager-app/reports/storage-flow/storage-flow.component';
import { OrderStatusReportComponent } from '@manager-app/reports/order-status-report/order-status-report.component';
import { StorageInvoicesReportsComponent } from '@manager-app/reports/storage-invoices-reports/storage-invoices-reports.component';
import { IncomeOutcomeComponent } from '@manager-app/reports/income-outcome/income-outcome.component';
import { UnderSalaryComponent } from '@manager-app/reports/under-salary/under-salary.component';
import { MoneyReportComponent } from '@manager-app/reports/money/money-report.component';
import { MoneyFlowReportComponent } from '@manager-app/reports/money-flow/money-flow-report.component';
import { RealizedProductComponent } from '@manager-app/reports/realized-product/realized-product.component';
import { StorageReportComponent } from '@manager-app/reports/storage-report/storage-report.component';
import { ProductReleaseComponent } from '@manager-app/reports/product-release/product-release.component';
import { ReportsBaseComponent } from '@manager-app/reports/reports-base.component';
import { SupplierPaymentComponent } from '@manager-app/reports/supplier-payment/supplier-payment.component';
import { DeliveryHeatCountMapComponent } from '@manager-app/reports/delivery-heat-count-map/delivery-heat-count-map.component';
import { InventoryManagementComponent } from '@manager-app/reports/inventory-management/inventory-management.component';
import { RevenueByProductComponent } from '@manager-app/reports/revenue-by-product/revenue-by-product.component';
import { ProfitLossStatementComponent } from '@manager-app/reports/profit-loss-statement/profit-loss-statement.component';
import { ReceivablesPayablesComponent } from '@manager-app/reports/receivables-payables/receivables-payables.component';
import { InventoryManagementDetailsComponent } from '@manager-app/reports/inventory-management/details/inventory-management-details.component';
import { InvoiceInfoComponent } from '@manager-app/reports/inventory-management/invoice-info/invoice-info.component';
import { CashFlowComponent } from '@manager-app/reports/cash-flow/cash-flow.component';
import { PaymentScheduleComponent } from '@manager-app/reports/payment-schedule/payment-schedule.component';
import { CancelOrdersComponent } from '@manager-app/reports/cancel-orders/cancel-orders.component';
import { ManagerSalesComponent } from '@manager-app/reports/manager-sales/manager-sales.component';

export const reportsRouting: Routes = [
  {
    path: '',
    component: ReportsBaseComponent,
    children: [
      {
        path: 'money',
        component: MoneyReportComponent,
      },
      {
        path: 'money-flow',
        component: MoneyFlowReportComponent,
      },
      {
        path: 'shipment-received',
        component: ReceivedReportComponent
      },
      {
        path: 'shipment-refunded',
        component: RefundedReportComponent
      },
      {
        path: 'sale',
        component: SaleReportComponent
      },
      {
        path: 'refund',
        component: RefundReportComponent
      },
      {
        path: 'revenue',
        component: RevenueReportComponent
      },
      {
        path: 'feedback-rating',
        component: FeedbackRatingReportComponent
      },
      {
        path: 'user-received-order',
        component: UserReceivedOrderComponent
      },
      {
        path: 'product-discard',
        component: ProductDiscardReportComponent
      },
      {
        path: 'product-discard/info',
        component: ProductDiscardInfoComponent
      },
      {
        path: 'storage-flow',
        component: StorageFlowComponent
      },
      {
        path: 'order-status',
        component: OrderStatusReportComponent
      },
      {
        path: 'storage-invoice',
        component: StorageInvoicesReportsComponent
      },
      {
        path: 'product-flow',
        component: IncomeOutcomeComponent
      },
      {
        path: 'under-salary',
        component: UnderSalaryComponent
      },
      {
        path: 'realized-products',
        component: RealizedProductComponent
      },
      {
        path: 'storage',
        component: StorageReportComponent
      },
      {
        path: 'product-release',
        component: ProductReleaseComponent
      },
      {
        path: 'supplier-payment',
        component: SupplierPaymentComponent
      },
      {
        path: 'delivery-heat-count-map',
        component: DeliveryHeatCountMapComponent
      },
      {
        path: 'inv-mgmt',
        component: InventoryManagementComponent
      },
      {
        path: 'revenue-by-product',
        component: RevenueByProductComponent
      },
      {
        path: 'profit-loss-statement',
        component: ProfitLossStatementComponent
      },
      {
        path: 'receivables-payables',
        component: ReceivablesPayablesComponent
      },
      {
        path: 'inv-mgmt-details',
        component: InventoryManagementDetailsComponent
      },
      {
        path: 'invoice-info',
        component: InvoiceInfoComponent
      },
      {
        path: 'cash-flow',
        component: CashFlowComponent
      },
      {
        path: 'payment-schedule',
        component: PaymentScheduleComponent
      },
      {
        path: 'cancel-orders',
        component: CancelOrdersComponent
      },
      {
        path: 'manager_sales_report',
        component: ManagerSalesComponent
      }
    ]
  }
];
